import produce from "immer";
import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { startCopyItems } from "../../../actions/copyAction";
import {
  startAddElement,
  startCopyElement,
} from "../../../actions/elementListAction";
import { Element } from "../../../models/elementModel";
import { Row } from "../../../models/rowModel";
import { Section } from "../../../models/sectionModel";
import { TabModel } from "../../../models/tabModel";
import { AppState } from "../../../reducers/rootReducer";
import { getAllRows } from "../../../selectors/rowListSelector";
import missingNumberFunc from "../elementNameGeneratingComponent";
import "./actionListComponent.scss";

export interface ActionListComponentProps {
  type: string;
  row?: Row;
  section?: Section;
  element?: Element;
}

const ActionListComponent: FC<ActionListComponentProps> = ({
  type,
  row,
  section,
  element,
}) => {
  const dispatch = useDispatch();
  const sessionState = useSelector((state: AppState) => state.session);
  const rowState = useSelector(getAllRows);
  const sectionState = useSelector((state: AppState) => state.sectionList);
  const elementState = useSelector((state: AppState) => state.elementList);
  const tabState = useSelector((state: AppState) => state.tabList);

  const duplicateItem = (elementType: string) => {
    //filter and sort relevent element list
    const elementListCount = elementState.present
      .filter((elementList) => {
        if (elementList.type === elementType) {
          return elementList;
        }
      })
      .sort((a, b) => {
        return a.sortKey > b.sortKey ? 1 : -1;
      });

    //get missing number
    const missingNumber = missingNumberFunc(
      elementListCount.map((elementListNo) => {
        return elementListNo.sortKey;
      })
    );

    

    if (type === "element" && element !== undefined) {
      if (element.type !== "tab" && element.type !== "table") {
        const newElement = produce(element, (draft) => {
          draft.name = `${draft.name.split('_')[0]}_${missingNumber}`
          draft.sortKey = missingNumber;
          draft = draft;
        });
        dispatch(startCopyElement(newElement, element));
      }
    }
  };

  return (
    <div className="row action-panel">
      {type === "element" &&
        element !== undefined &&
        element.type !== "tab" &&
        element.type !== "table" && (
          <i
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              duplicateItem(`${element.type}`);
            }}
            className="fa fa-clone"
          ></i>
        )}
      <i className="fa fa-arrows-alt"></i>
    </div>
  );
};

export default ActionListComponent;
